<template>
  <div class="d-flex flex-column align-center py-10">
    <v-col
      cols="12"
      md="8"
      class="text-center"
    >
      <h2
        v-if="fields.heading && fields.heading.length"
        class="h3 secondary--text"
      >
        {{ fields.heading }}
      </h2>
      <ctf-rich-text
        v-if="fields.subHeading && fields.subHeading.content.length"
        class="mt-5"
        :document="fields.subHeading"
      />
    </v-col>
    <v-col
      cols="12"
      md="9"
    >
      <div
        v-if="topics && topics.length"
        class="text-left expansion-panel-faq-wrapper"
      >
        <div
          v-for="(topic, i) in topics"
          :key="'expansion-panel-faq-topic_' + i"
          class="mt-3"
        >
          <h3 class="h4 secondary--text topic-title">
            {{ topic.fields.title }}
          </h3>
          <div
            v-for="(question, j) in topic.fields.questions"
            :key="'topic-question-' + question.fields.title + '_' + j"
          >
            <div
              class="permanent-divider"
            >
              <h4 class="font-large ml-4">{{ question.fields.title }}</h4>
            </div>
            <div class="ml-4" :id="'topic-question-' + question.fields.title.replace(/[\W]/gi, '') + '_' + j">
              <div class="dark-gray--text" v-html="question.fields.answer"/>
            </div>
          </div>
        </div>
      </div>
    </v-col>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { queryCTF, sortCTFEntries } from '@/plugins/contentful'
import PixelTracker from '@/components/base/pixel-tracker'

export default {
  name: 'ExpansionPanelFaq',
  props: {
    fields: {
      type: Object,
      required: true
    },
    sysId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      topics: null,
      panels: [],
      tracked: false
    }
  },
  computed: {
    ...mapState({ siteConfig: state => state.site.siteConfig })
  },
  mounted () {
    setTimeout(() => {
      const faqPanels = document.getElementsByClassName('v-expansion-panel')
      for (let i = 0; i < faqPanels.length; i++) {
        faqPanels[i].setAttribute('aria-expanded', 'false')
      }
      const faqButtons = document.getElementsByClassName('v-expansion-panel-header')
      for (let i = 0; i < faqButtons.length; i++) {
        faqButtons[i].setAttribute('aria-expanded', 'false')
      }
    }, 500) // setting a timeout allows this script to run after framework interference
  },
  async created () {
    if (this.fields.topics && this.fields.topics.length > 0) {
      this.topics = await this.fetchTopics()
    } else {
      this.topics = await this.fetchAllTopicsInSite()
    }
  },
  methods: {
    async fetchTopics () {
      const { items, includes } = await queryCTF(
        `&include=2&content_type=faq&select.fields&sys.id=${this.sysId}`
      )
      if (items && includes) {
        const group = items[0]
        const entries = includes.Entry.filter(x =>
          group.fields.topics.find(t => t.sys.id === x.sys.id)
        )
        entries.forEach(entry => {
          entry.fields.questions = sortCTFEntries(entry.fields.questions, includes.Entry)
        })
        return sortCTFEntries(this.fields.topics, includes.Entry)
      }
    },
    async fetchAllTopicsInSite () {
      const { items, includes } = await queryCTF(
        '&content_type=medicareTopics&select.fields'
      )
      if (items && includes) {
        items.forEach(({ fields }) => {
          fields.questions = fields.questions
            .map(q => {
              return {
                ...q,
                fields: includes.Entry.find(e => e.sys.id === q.sys.id).fields
              }
            })
            .sort((a, b) => {
              return a.sys.id.toUpperCase() > b.sys.id.toUpperCase() ? -1 : 1
            })
        })
        const thisSitesTopics = items.filter(x =>
          x.fields.sites.some(y => y.sys.id === this.siteConfig.id)
        )
        return thisSitesTopics
      }
    },
    onTopicClick (index) {
      this.panels = this.panels.map((p, i) => {
        if (index === i) {
          return p
        }
        return -1
      })
      if (!this.tracked && this.siteConfig.careNetworkName.indexOf('Vermont') === -1) {
        PixelTracker.track('601117795', 'DwUUCLnih9wBEOOo0Z4C')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables";

.v-application .v-card,
.v-application .v-expansion-panel:before,
.v-application .v-stepper .stepper-step-wrapper {
  box-shadow: none;
  border: none;
}

::v-deep .v-expansion-panel {
  .v-expansion-panel-header--active {
    color: $black !important;
    .v-expansion-panel-header__icon {
      i {
        color: $error !important;
      }
    }
  }
  .v-expansion-panel-header__icon {
    position: absolute;
    margin: auto -24px;
    i {
      color: $primary !important;
    }
  }
}

h4 {
  font-size: 17px !important;
  font-weight: 700;
  line-height: 33px;
  padding-bottom: 10px;
  padding-top: 10px;
}

.v-expansion-panels {
  justify-content: unset !important;
}

.dark-gray--text {
  color: #646464!important;
  letter-spacing: 0;
  line-height: 1.5;
  font-size: 16px;
  padding-bottom: 16px;
  padding-left: 16px;
}

.topic-title {
  text-align: start;
  margin-left: 16px;
  margin-bottom: 15px;
}

.permanent-divider {
  border-top: 1px solid #BDBDBD;
  border-radius: 0;
}
</style>
